import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://videojson-api.herokuapp.com",
});

export default axiosInstance;
